<div class="container">
    <div class="row justify-content-start">
        <div class="col-4">
            <input type="text" class="form-control" placeholder="ค้นหาสมาชิกด้วยเบอร์โทร" value="082781352"
                (change)="getMemberByTel(tel)" #tel>
        </div>
    </div>
</div>
<br>
<div class="container" *ngIf="!memberItem?.Member_id">
    <h1>ไม่พบสมาชิก</h1>
</div>
<div class="container" *ngIf="memberItem?.Member_id">
    <div class="row g-3">
        <div class="col-5">
            <div class="card">
                <div class="profile">
                    <img height="100px" src="{{memberItem.Rank_image}}" alt="">
                    <b>คุณ : {{memberItem.Member_name}}</b>
                    <b class="ms-3">แต้มทั้งหมด : {{memberItem.Point}}</b>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row g-3">
        <div class="col-12">
            <h3>รางวัล</h3>
        </div>
        <div class="col-xl-4 col-lg-6 col-12" *ngFor="let items of rewardItems">
            <div class="card cardItem">
                <div class="reward">
                    <div class="reward-left">
                        <div class="logo">
                            <img src="{{items.Image}}" alt="MacDonalds Logo">
                        </div>
                    </div>
                    <div class="reward-right">
                        <h1 *ngIf="items.Type =='discount'">ส่วนลด</h1>
                        <span *ngIf="items.DisType == 'amount' && items.Type =='discount'"><span
                                class="amount">{{items.DisAmount}}</span> บาท
                        </span>
                        <span *ngIf="items.DisType == 'percentage' && items.Type =='discount'"><span
                                class="amount">{{items.DisAmount}}</span> %
                        </span>
                        <h1 *ngIf="items.Type =='things'">รางวัล</h1>
                        <span *ngIf="items.Type =='things'"><span class="amount">{{items.Name}}</span>
                        </span>
                        <span class="valid">ใช้ <b>{{items.Point}}</b> แต้มในการแลกของรางวัล</span>
                        <button class="btn btn-primary" *ngIf="memberItem.Point > items.Point"
                            (click)="redeem(items)">แลกรางวัล</button>
                        <button class="btn btn-cancel" disabled
                            *ngIf="memberItem.Point < items.Point">แต้มไม่พอ</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>